import {  IBaseRequest } from "./Base";

export enum SeverityEnum {
	LogInfo = 0,
	LogWarning = 1,
	LogError = 2,
}

export interface ILoggingRequest extends IBaseRequest {
	Message: string;
	Severity: SeverityEnum;
}


